import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { deleteScheduleSuccess, deleteScheduleFailed, editScheduleFailed, editScheduleSuccess } from '../actions';
import { ScheduleEmailReportTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};



// edit schedule
export function* editScheduleSettings({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/report-settings/${data.id}`;

  const response = yield request({
    method: 'put',
    data,
    url,
  });

  if (response.success) {
    yield put(editScheduleSuccess(response.raw));
    Notify('Schedule updated successfully', {
      position: 'top-right',
      status: 'success',
    });
    if (cb && typeof cb === 'function') {
      cb();
    }
  } else {
    
    networkErrorHandler(response?.statusCode, `Failed to update Schedule: ${response.message}`);
    yield put(editScheduleFailed(response.message));
  }
}

export function* edittingScheduleSettings() {
  yield takeEvery(ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS, editScheduleSettings);
}

// deleting schedule
export function* deleteSchedule({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/report-settings/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  
  if (response.success) {
    yield put(deleteScheduleSuccess(id));
    cb();
    Notify('Schedule deleted successfully', {
      position: 'top-right',
      status: 'success',
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to delete Schedule: ${response.message}`);
    yield put(deleteScheduleFailed(response.message));
  }
}

export function* deletingScheduleSettings() {
  yield takeEvery(ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS, deleteSchedule);
}